/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './LeilaoDeVeiculosFiqueAtento.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';

function LeilaoDeVeiculosFiqueAtento() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="leilao-de-veiculos-fique-atento">
        <ContainerHome24>
          <div className="fique-atento-contain">
            <div className="fique-atento-textos">
              <h2 className="fique-atento-titulo">Fique atento</h2>
              <div className="fique-atento-texto">
                <p>
                  <b>.</b> Verifique o veículo antes do leilão para garantir que o carro ou moto não
                  possua nenhuma avaria;
                </p>
                <p>
                  <b>.</b> Confira o valor do veículo na tabela FIPE e entenda o quanto você pode
                  pagar.
                </p>
              </div>
            </div>
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width < 992 && (
                  <img
                    src="assets/leilao-de-veiculos/img-leiloes-fique-atento.svg"
                    alt="Um telefone com uma pessoa acessando uma pagina de leilao de carro"
                    className="fique-atento-img"
                  />
                )}
              </>
            )}
            <WhiteButton
              href="blog/leilao-de-veiculos-de-financeira.html"
              target="_blank"
              className="fique-atento-btn"
            >
              Saiba mais
            </WhiteButton>
          </div>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width >= 992 && (
                <img
                  src="assets/leilao-de-veiculos/img-leiloes-fique-atento.svg"
                  alt="Um telefone com uma pessoa acessando uma pagina de leilao de carro"
                  className="fique-atento-img"
                />
              )}
            </>
          )}
        </ContainerHome24>
      </section>
      <section id="leilao-de-veiculos-disclaimer">
        <ContainerHome24>
          <p className="leilao-de-veiculos-disclaimer-texto">
            Sujeito a alteração da data do leilão. Em caso de dúvida, consultar o site do leiloeiro.
          </p>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default LeilaoDeVeiculosFiqueAtento;
